import { ResponseStructure } from './../../../../../../libs/share/src/lib/_models/shared-models';
import { StaffService } from './../../_services/staff.service';
import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../global/global.service';
import { MentorshipService } from '../../_services/mentorship.service';
import { Subscription, from } from 'rxjs';
import { Staff } from '../../_models/mentorship';
import { ActivatedRoute } from '@angular/router';
import { PaginationInfo } from '../../_models/pagination-info';
import { co } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'iq-central-front-end-mentorship',
  templateUrl: './mentorship.component.html',
  styleUrls: ['./mentorship.component.scss'],
})
export class MentorshipComponent implements OnInit {
  emptyMentee: boolean;
  constructor(
    private _global: GlobalService,
    private _staff: StaffService,
    private _activatedRoute: ActivatedRoute,
    private _mentorshipService: MentorshipService
  ) {}

  sub: Subscription = new Subscription();
  staffs: Staff[];
  filteredStaffs: any;
  mentors: any[] = [];
  mentorId: any;
  mentees: any[] = [];
  selectedMentees: Staff[] = [];
  selectedMentors: Staff[] = [];
  paginationInfo: PaginationInfo;
  ngOnInit(): void {
    this.getResolvedData();

    this.emptyMentee = false;
  }

  getResolvedData() {
    this.sub.add(
      this._activatedRoute.data.subscribe((response) => {
        this.staffs = this.filteredStaffs =
          response['resolvedData'].staffs['responseResult'].users;

        this.paginationInfo =
          response['resolvedData'].staffs['responseResult'].paginationInfo;
        this.mentors = response['resolvedData'].mentors['responseResult'];
      })
    );
  }

  selectDeselectMentors(mentor) {
    this.selectedMentors.includes(mentor)
      ? (this.selectedMentors = this.selectedMentors.filter(
          (m) => m !== mentor
        ))
      : this.selectedMentors.push(mentor);

    // console.log(this.selectedMentors);
  }

  selectDeselectMentees(mentee) {
    this.selectedMentees.includes(mentee)
      ? (this.selectedMentees = this.selectedMentees.filter(
          (m) => m !== mentee
        ))
      : this.selectedMentees.push(mentee);

    // console.log(this.selectedMentees);
  }

  addMentors() {
    this._global.showSpinner();
    const mentorsIds = this.selectedMentors.map((m) => m.id);
    const payload = { mentors: mentorsIds };

    this.sub.add(
      this._mentorshipService.createMentor(payload).subscribe({
        next: (res: ResponseStructure) => {
          this.mentors.push(...res.responseResult);
          this._global.globalSuccessHandler({
            ...res,
            responseResult: 'Mentor(s) added successfully',
          });
        },
      })
    );
  }

  assignMentees() {
    this._global.showSpinner();
    const menteesIds = this.selectedMentees.map((m) => m.id);
    this.sub.add(
      this._mentorshipService
        .assignMentor({ mentees: menteesIds, mentorId: this.mentorId })
        .subscribe({
          next: (res: ResponseStructure) => {
            this._global.globalSuccessHandler(res);
            this.selectedMentees.forEach((m) => {
              this.mentees.push(m);
            });
          },
        })
    );
  }

  deleteMentor(mentorId) {
    this._global.showSpinner();
    this.sub.add(
      this._mentorshipService.deleteMentor(mentorId).subscribe({
        next: (res: ResponseStructure) => {
          this._global.globalSuccessHandler(res);
          this.mentors = this.mentors.filter((m) => {
            return m.id !== mentorId;
          });
        },
      })
    );
  }

  setMentor(mentorId, mentees) {
    this.mentorId = mentorId;
    this.mentees = mentees;

    // const dltCheck = document.querySelectorAll('.dlt-check');
    // for(let i = 0; i < dltCheck?.length; i++) {
    //   // if(dltCheck[i].classList.contains('dark')) {
    //   //   dltCheck[i].classList.remove('dark');
    //   //   dltCheck[i].classList.add('white');
    //   // } else {
    //   //   dltCheck[i].classList.remove('white');
    //   //   dltCheck[i].classList.add('dark');
    //   // }
    // }
  }

  navigatePage(page) {
    this._staff.getActiveEnterpriseUsers(page, 5).subscribe({
      next: (res) => {
        this.staffs = res['responseResult'].users;
        this.paginationInfo = res['responseResult'].paginationInfo;
      },
    });
  }

  filter(query: string) {
    this.staffs = query
      ? this.filteredStaffs.filter((c) =>
          c.user?.fullName.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredStaffs;
  }
}
